import React from "react";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";

import useAuth from "../../../../hooks/useAuth";

import QDLoader from "../../../../components/QDLoader";
import BCDModule from "../../../../components/dashboard/modules/bcd/BCDModule";
import Header from "./Header";
import { useTranslation } from "../../../../hooks/useLocalization";

const BCDModulePage = () => {
  const { t } = useTranslation();
  const { isInitialized } = useAuth();
  return (
    <React.Fragment>
      <Helmet title={t("BCD")} />
      <Container fluid className="p-0">
        {isInitialized && <Header />}
        {isInitialized ? <BCDModule /> : <QDLoader />}
      </Container>
    </React.Fragment>
  );
};

export default BCDModulePage;
